import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import CohortCalendarWaitlist from '../components/CohortCalendarWaitlist';
import TechnologyPartnerships from '../components/TechnologyPartnerships';
import TestimonialsSection from '../components/TestimonialsSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <CohortCalendarWaitlist />
      <TechnologyPartnerships />
      <TestimonialsSection />
      <Footer />
    </div>
  );
};

export default HomePage;
